'use strict';

const $ = window.jQuery;

module.exports = function () {
    $('.expand-cookies-details').on('click', function () {
        $('.cookie-notice-params').niceScroll({
            cursorcolor: '#b61823',
            cursorwidth: '5px',
            cursorborder: '0',
            cursorborderradius: '5px'
        });
    });
};
